const turnosAutoCheckInitialState = {
    turnosAutoCheckIn : {
        data: [], 
        loading: false, 
        error: false 
    }
}

export default turnosAutoCheckInitialState; 